import FJTextToSpeechBottom from '../view/FJTextToSpeechBottom.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import { useMemo, useState, useEffect } from 'react';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import FJEvent from '../../../../store/FJEvent.js';
import FJTTSPlayStore from '../../../../store/FJTTSPlayStore.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDropDownManager from '../../../../common/js/FJDropDownManager.js';
import FJUtil from '../../../../util/FJUtil.js';

const FJTextToSpeechBottomContainer = () => {
    useLocalStore();
    const currentSpeechList = useSelector(state => state.textToSpeech.currentSpeechList);
    const freeNumCreationTextToSpeech = useSelector(state => state.textToSpeech.freeNumCreationTextToSpeech);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const currentBottomCurrentTime = useSelector(state => state.textToSpeech.currentBottomCurrentTime);
    const currentBottomTotalTime = useSelector(state => state.textToSpeech.currentBottomTotalTime);
    const isPlayingInBottom = useSelector(state => state.textToSpeech.isPlayingInBottom);
    // const currentBottomSpeechId = useSelector(state => state.textToSpeech.currentBottomSpeechId);
    const speechSelectId = useSelector(state => state.textToSpeech.speechSelectId);
    const downloadStatus = useSelector(state => state.textToSpeech.downloadStatus);

    const needGenerateList = currentSpeechList.filter(item => item.status === FJConstant.DEFAULT && item.text.trim());

    const [selectedSpeechIdList, setSelectedSpeechIdList] = useState([]);
    const dispatch = useDispatch();

    const showSpeechList = useMemo(() => {
        return currentSpeechList.filter(item => !!item.text.trim());
    }, [currentSpeechList]);

    const _setIsSelectAll = bool => {
        if (bool) {
            setSelectedSpeechIdList(showSpeechList.map(item => item.id));
        } else {
            setSelectedSpeechIdList([]);
        }
    };

    // useEffect(() => {
    //     const filterIdList = selectedSpeechIdList.filter(id => currentSpeechList.find(item => item.id === id));
    //     setSelectedSpeechIdList(filterIdList);
    // }, [currentSpeechList, selectedSpeechIdList]);

    const _onHide = () => {
        setSelectedSpeechIdList([]);
    };

    const _onShow = () => {
        _setIsSelectAll(true);
    };

    const _onDownload = () => {
        FJDropDownManager.hideAll();
        dispatch(FJActionTextToSpeech.onDownloadAction(selectedSpeechIdList));
    };

    const _onEditToFlexClip = () => {
        FJDropDownManager.hideAll();
        dispatch(FJActionTextToSpeech.onEditToFlexCliAction(selectedSpeechIdList));
    };

    const _onChangePlay = () => {
        if (!isPlayingInBottom) {
            const garaNum = needGenerateList.length;
            let totalCre = 0;
            let characterLength = 0;
            needGenerateList.forEach(item => {
                characterLength = characterLength + item.text.trim().length;
                totalCre = totalCre + FJTextToSpeechUtil.getUsedCreditByTextLength(item.text.trim().length);
            });
            totalCre = parseFloat(totalCre.toFixed(3));
            FJUtil.eaLog('whole_speech_play', { character: characterLength, session_num: garaNum, credits: totalCre });
        }
        if (currentBottomCurrentTime === 0) {
            FJTTSPlayStore.enterGlobalPlay();
        }
        FJEvent.dispatch(FJ_EVENT_TYPE.CHANGE_PLAY_CURRENT_SPEECH_BY_ID, speechSelectId);
    };

    const isPlayLoading = useMemo(() => {
        const item = currentSpeechList.find(item => item.id === speechSelectId);
        return item?.status === FJConstant.GENERATING;
    }, [currentSpeechList, speechSelectId]);

    const getTip = () => {
        if (creditNumber <= 0) {
            return;
        }
        const garaNum = needGenerateList.length;
        let totalCre = 0;
        needGenerateList.forEach(item => {
            totalCre = totalCre + FJTextToSpeechUtil.getUsedCreditByTextLength(item.text.trim().length);
        });
        totalCre = parseFloat(totalCre.toFixed(3));
        let tooltip = null;
        if (garaNum > 0) {
            if (garaNum === 1) {
                tooltip = FJLocalStore._('section-credits').replace('xxx', totalCre).replace('xx', garaNum);
            } else {
                tooltip = FJLocalStore._('sections-credits').replace('xxx', totalCre).replace('xx', garaNum);
            }
        }
        return tooltip;
    };

    return (
        <FJTextToSpeechBottom
            list={showSpeechList}
            selectedSpeechIdList={selectedSpeechIdList}
            setSelectedSpeechIdList={setSelectedSpeechIdList}
            setIsSelectAll={_setIsSelectAll}
            onHide={_onHide}
            onShow={_onShow}
            onDownload={_onDownload}
            freeNumCreation={freeNumCreationTextToSpeech}
            creditNumber={creditNumber}
            currentTime={currentBottomCurrentTime}
            totalTime={currentBottomTotalTime}
            isPlaying={isPlayingInBottom}
            onChangePlay={_onChangePlay}
            downloadStatus={downloadStatus}
            onEditToFlexClip={_onEditToFlexClip}
            isPlayLoading={isPlayLoading}
            tooltip={getTip()}
        />
    );
};
export default FJTextToSpeechBottomContainer;
